"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconProgressDone = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconProgressDone = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 0c6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12S0 18.628 0 12C0 5.373 5.373 0 12 0zm6.394 7.052a1.694 1.694 0 00-2.398 0l-5.994 5.994a.43.43 0 01-.606 0l-2.214-2.213a1.696 1.696 0 00-2.398 2.398L8.5 16.947a1.699 1.699 0 002.398 0l7.496-7.497a1.694 1.694 0 000-2.398z"
}));
exports.IconProgressDone = IconProgressDone;
//# sourceMappingURL=IconProgressDone.js.map